import {Component, ElementRef, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {TilesService} from '../../../../../core/services/tiles.service';
import {TilePollingService} from '../../../../../core/services/tile-polling.service';
import {TileBaseComponent} from '../tile-base.component';
import {TILE_TYPE_SIMPLE_MULTISTATE} from '../../../../../shared/models/tile';
import {TileMultiChoiceElemSetup} from '../../../../../shared/models/tile-template/interfaces';
import {ShadeToolsService} from '../../../../../core/services/shade-tools.service';
import {SimpleMultistateStructure} from '../../../../../shared/models/structure';
import {Option, OptionGroup} from '../../../../../shared/models/option';
import {AlarmsService} from '../../../../../core/services/alarms.service';
import {TileHistoryService} from '../../../../../core/services/tile-history.service';
import {SessionService} from '../../../../../core/services/session.service';
import {TileAlarmBadgeComponent} from '../../alarm-badge/tile-alarm-badge.component';
import {PopoverMenuComponent} from '../../../popover-menu/popover-menu.component';
import {SpinnerComponent} from '../../../spinner/spinner.component';
import {SchedulesViewerComponent} from '../../../schedules-viewer/schedules-viewer.component';
import { PermissionsService } from 'src/core/services/permissions.service';
import { MotiChatService } from 'src/moti/services/moti-chat.service';
import { ViewportIntersectionService } from '../../../../../core/services/viewport-intersection.service';
import {TooltipDirective} from '../../../../directives/tooltip/tooltip.directive';

@Component({
  selector: 'motn-tile-multi-choice',
  templateUrl: './tile-multi-choice.component.html',
  styleUrls: ['./tile-multi-choice.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TileAlarmBadgeComponent,
    PopoverMenuComponent,
    SpinnerComponent,
    SchedulesViewerComponent,
    TooltipDirective,
  ],
})
export class TileMultiChoiceComponent extends TileBaseComponent implements OnInit {
  @Input() elemDef: TileMultiChoiceElemSetup;

  structure: SimpleMultistateStructure;

  changeValueMenuOpen: boolean = false;
  changeValueMenuOptions: OptionGroup;


  constructor(
    protected tilesService: TilesService,
    protected tilePollingService: TilePollingService,
    protected shadeTools: ShadeToolsService,
    protected alarmsService: AlarmsService,
    protected tileHistoryService: TileHistoryService,
    protected permissionsService: PermissionsService,
    protected session: SessionService,
    protected motiChatService: MotiChatService,
    protected elementRef: ElementRef,
    protected viewportService: ViewportIntersectionService,
  ) {
    super(tilesService, tilePollingService, shadeTools, alarmsService, tileHistoryService, permissionsService, session, motiChatService, elementRef, viewportService);
  }


  protected onInit(): void {
    this.structure = this.tile.Structure as SimpleMultistateStructure;
  }


  protected onDestroy(): void {
  }


  showChangeValueMenu(): void {
    if (!this.structure.Writable || this.sendingValue) {
      return;
    }

    this.changeValueMenuOptions = this.generateMultiChoiceOptions();
    this.changeValueMenuOpen = true;
  }


  hideChangeValueMenu(): void {
    setTimeout(() => {
      this.changeValueMenuOpen = false;
    }, 100);
  }


  private generateMultiChoiceOptions(): OptionGroup {
    const options: Option[] = [];

    if (this.tile.Type === TILE_TYPE_SIMPLE_MULTISTATE) {
      const appearance = this.tile.Appearance;

      for (let displayState of this.structure.DisplayStates) {
        const rawValue = displayState.CompareFunc.Value;
        const displayValue = this.tileValueParser.getDisplayValue(rawValue);

        options.push({
          id: '' + rawValue,
          name: displayValue,
          callback: () => {
            this.sendMultistateTileValue(rawValue);
          },
          selected: this.rawValue === rawValue,
        });
      }
    } else {
      throw new Error('unsupported tile type for generateMultiChoiceOptions');
    }

    return new OptionGroup(options);
  }
}
